import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import LoadingScreen from "../../Admin/Loading_Screen/LoadingScreen";
import API_BASE_URL from "../../ApiConfig/ApiConfig";

const CustomerSchemeTable = ({ records, onViewInvoice }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedSchemes, setSelectedSchemes] = useState([]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const token = Cookies.get("admin");
  const handleCheckboxChange = (customerId, schemeId, ticketNo, purchaseDate, purchaseFrom, invoiceAmount) => {
    console.log("Checkbox clicked:", { customerId, schemeId, ticketNo, purchaseDate, purchaseFrom, invoiceAmount });
  
    setSelectedSchemes((prev) => {
      const isSelected = prev.some(
        (item) =>
          item.customerId === customerId &&
          item.schemeId === schemeId &&
          item.ticketNo === ticketNo
      );
    
      if (isSelected) {
        return prev.filter(
          (item) =>
            !(
              item.customerId === customerId &&
              item.schemeId === schemeId &&
              item.ticketNo === ticketNo
            )
        );
      } else {
        return [
          ...prev,
          {
            customerId: customerId || "N/A",
            schemeId: schemeId || "N/A",
            ticketNo: ticketNo || "N/A",
            purchaseDate: purchaseDate || "N/A",
            purchaseFrom: purchaseFrom || "N/A",
            invoiceAmount: invoiceAmount ?? 0,  // ✅ Default value 0 agar undefined ho
          },
        ];
      }
    });
  }    
  
  
  
  const updateSelectedSchemesStatus = async (status) => {
    if (selectedSchemes.length === 0) {
      setMessage("Please select at least one scheme.");
      return;
    }
  
    const newStatus = status === "Approved" ? "In Process" : status;
    setLoading(true);
  
    try {
      console.log(`Updating scheme status to '${newStatus}' for selected schemes.`);
  
      const requestData = {
        schemes: selectedSchemes.map(({ customerId, schemeId, ticketNo, purchaseDate, purchaseFrom, invoiceAmount }) => ({
          customerId,
          schemeId,
          ticketNo,
          purchaseDate,
          purchaseFrom,
          invoiceAmount,
          status: newStatus,
        })),
      };
  
      console.log("Final Request Payload:", JSON.stringify(requestData, null, 2)); // ✅ Debugging log
  
      const response = await axios.post(
        `${API_BASE_URL}/Scheme/update-status`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );
  
      console.log("Response:", response.data);
      setMessage(`Selected schemes updated to '${newStatus}'.`);
    } catch (error) {
      console.error("Error updating scheme statuses:", error.response?.data || error.message);
      setMessage(error.response?.data?.message || "Error updating scheme statuses.");
    } finally {
      setLoading(false);
    }
  };
  
  


  const handleRejectClick = () => {
    if (selectedSchemes.length === 0) {
      setMessage("Please select at least one scheme.");
      return;
    }
    setShowRejectModal(true);
  };

  const submitRejection = async () => {
    if (!rejectionReason.trim()) {
      setMessage("Please provide a rejection reason.");
      console.warn("Rejection attempted without a reason.");
      return;
    }
  
    if (selectedSchemes.length === 0) {
      setMessage("Please select at least one scheme.");
      console.warn("Attempt to reject without selecting any scheme:", selectedSchemes);
      return;
    }
  
    setLoading(true);
    try {
      console.log("Rejecting multiple schemes:", selectedSchemes);
  
      const requestData = {
        schemes: selectedSchemes.map(({ customerId, schemeId, ticketNo, purchaseDate, purchaseFrom, invoiceAmount }) => ({
          customerId,
          schemeId,
          ticketNo,
          purchaseDate,
          purchaseFrom,
          invoiceAmount,
          status: "Rejected",
          rejectionReason,
        })),
      };
  
      console.log("Request Payload:", requestData);
  
      const response = await axios.post(
        `${API_BASE_URL}/Scheme/update-status`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );
  
      console.log("Rejection Response:", response.data);
      setMessage("Selected schemes rejected.");
      setShowRejectModal(false);
      setRejectionReason("");
    } catch (error) {
      console.error("Error rejecting schemes:", error.response?.data || error.message);
      setMessage(error.response?.data?.message || "Error rejecting schemes.");
    } finally {
      setLoading(false);
    }
  };
  
  
  const handleReasonClick = (reason) => {
    setSelectedReason(reason);
    setShowReasonModal(true);
  };

  return (
    <div className="overflow-x-auto modal-content modal-scrollbar">
    {loading && <LoadingScreen />}
    {message && <div className="text-red-600 my-4 font-semibold">{message}</div>}
  
    <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg overflow-hidden">
      <thead className="bg-gray-200 text-gray-800">
        <tr>
          <th className="px-6 py-4 text-left text-sm font-medium">Select</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Ticket No</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Scheme ID</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Scheme Name</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Date</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Status</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Purchase Date</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Purchase From</th>
          <th className="px-6 py-4 text-left text-sm font-medium">Invoice Amount</th>
          <th className="px-6 py-4 text-center text-sm font-medium">View</th>
        </tr>
      </thead>
      <tbody>
        {records.map((record) => (
          <tr
            key={`${record.customerId}-${record.schemeId}-${record.ticketNo}`}
            className="border-t border-gray-300 hover:bg-gray-100"
          >
            <td className="px-6 py-4">
              <input
                type="checkbox"
                checked={selectedSchemes.some(
                  (item) =>
                    item.customerId === record.customerId &&
                    item.schemeId === record.schemeId &&
                    item.ticketNo === record.ticketNo &&
                    item.purchaseDate === record.purchaseDate &&
                    item.purchaseFrom === record.purchaseFrom &&
                    item.invoiceAmount === record.invoiceAmount
                )}
                onChange={() =>
                  handleCheckboxChange(
                    record.customerId,
                    record.schemeId,
                    record.ticketNo,
                    record.purchaseDate,
                    record.purchaseFrom,
                    record.invoiceAmount
                  )
                }
                disabled={record.status === "Approved" || record.status === "Rejected" || record.status === "In Process"}
              />
            </td>
            <td className="px-6 py-4 text-sm">{record.ticketNo}</td>
            <td className="px-6 py-4 text-sm">{record.schemeId}</td>
            <td className="px-6 py-4 text-sm">{record.schemeName}</td>
            <td className="px-6 py-4 text-sm">{new Date(record.schemeEndDate).toLocaleDateString()}</td>
            <td className="px-6 py-4 text-sm">
              <span
                className={`px-3 py-1 rounded-lg text-sm ${record.status === "Approved"
                  ? "bg-green-200 text-green-800"
                  : record.status === "Rejected"
                    ? "bg-red-200 text-red-800 cursor-pointer"
                    : record.status === "In Process"
                      ? "bg-yellow-300 text-yellow-900"
                      : "bg-yellow-200 text-yellow-800"
                  }`}
                onClick={() =>
                  record.status === "Rejected" &&
                  handleReasonClick(record.rejectionReason)
                }
              >
                {record.status}
              </span>
            </td>
            <td className="px-6 py-4 text-sm">{new Date(record.purchaseDate).toLocaleDateString("en-GB")}</td>
            <td className="px-6 py-4 text-sm">{record.purchaseFrom}</td>
            <td className="px-6 py-4 text-sm">{record.invoiceAmount}</td>
            <td className="px-6 py-4 flex justify-center">
              <button
              
                onClick={() => onViewInvoice(record.invoiceFile)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1C50A3] font-bold underline"
              >
                View
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  
    <div className="flex justify-end mt-4 space-x-4">
      <button
        className="bg-[#1C50A3] text-white px-4 py-2 rounded-[4px] hover:bg-green-700 transition duration-200"
        onClick={() => updateSelectedSchemesStatus("Approved")}
      >
        Approve Selected
      </button>
      <button
        className="bg-red-600 text-white px-4 py-2 rounded-[4px] hover:bg-red-700 transition duration-200"
        onClick={handleRejectClick}
      >
        Reject Selected
      </button>
    </div>
  
    {showRejectModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-lg font-semibold mb-3">Enter Rejection Reason</h2>
          <textarea
            className="w-full border border-gray-300 p-2 rounded-lg"
            rows="4"
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
          ></textarea>
          <div className="flex justify-end space-x-3 mt-4">
            <button
              className="bg-gray-500 text-white px-3 py-1 rounded-lg hover:bg-gray-600 transition duration-200"
              onClick={() => setShowRejectModal(false)}
            >
              Cancel
            </button>
            <button
              className="bg-red-600 text-white px-3 py-1 rounded-lg hover:bg-red-700 transition duration-200"
              onClick={submitRejection}
            >
              Reject
            </button>
          </div>
        </div>
      </div>
    )}
  
    {showReasonModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-lg font-semibold mb-3">Rejection Reason</h2>
          <p className="border border-gray-300 p-3 rounded-lg">{selectedReason || "No reason provided"}</p>
          <button
            className="bg-gray-500 text-white px-3 py-1 rounded-lg mt-4 hover:bg-gray-600 transition duration-200"
            onClick={() => setShowReasonModal(false)}
          >
            Close
          </button>
        </div>
      </div>
    )}
  </div>
  );
};

export default CustomerSchemeTable;